




















import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import ModalView from '@/components/helper/modal-view.vue';
import FormBase from '@/components/helper/form-base.vue';
import Util from '@/lib/util';
import url from '@/lib/url'
import ListBase from '@/lib/listbase';
import Manufacturer from '@/store/entities/admin/manufacturer';

@Component({
    components: { ModalView, FormBase },
    watch: {
        value: function (val) {
            let obj = (this as any);
            obj.modalShow = val;
            if (val) {
                obj.image = null;
                obj.manufacturer = Util.extend(true, {}, this.$store.state.manufacturer.editModel);
                obj.initForm();
            } else
                this.$emit('input', false);
        },
        modalShow: function (val) {
            if (!val) this.$emit('input', false);
        }
    }
})

export default class ManufacturerForm extends ListBase {
    @Prop({ type: Boolean, default: false }) value: boolean;
    manufacturer: Manufacturer = new Manufacturer();
    modalShow: boolean = false;
    image: any = null;
    modalSetting: any = {
        entity: "manufacturer",
        title: 'Marca',
        width: "500px",
        showForm: false,
    };
     
    items = [
        this.gItem({ type: 'text', prop: 'name', label: 'Nombre', size: 12, required: true }),
        this.gItem({ type: 'active', size: 12 }), 
    ]

    get imageUrl() {
        return (this.image != null ? this.image :
            (this.manufacturer.image_url != null ? this.manufacturer.image_url : null));
    }

    openImage() {
        (this.$refs.fileInput as any).click();
    }

    onFileChange() {
        let ipt = (this.$refs.fileInput as any);
        if (ipt.files == undefined) return;
        if (ipt.files.length > 0) {
            if (!ipt.files.length)
                return;
            let file = ipt.files[0];

            let reader = new FileReader();
            let vm = this;
            reader.onload = (e) => {
                vm.image = (e as any).target.result;
            };
            reader.readAsDataURL(file);
        }
    }

    initForm() {   
    }

    async save() {
        if ((this.$refs.entityForm1 as any).validate()) {
            let model = Util.extend(true, {}, this.manufacturer);
            if (this.image != null)
                model.imageData = this.image;

            await this.$store.dispatch({
                type: 'manufacturer/' + (this.manufacturer.id > 0 ? 'update' : 'create'),
                data: model
            });
            this.$emit('save-success');
            this.cancel();
            if (this.manufacturer.id > 0)
                Util.abp.notify.success(this, 'Informacion de Marca actualizada!');
            else
                Util.abp.notify.success(this, 'La Marca ha sido creada!');
        }
    }  

    cancel() {
        this.$emit('input', false);
    }

    mounted() {
    }

    created() {
    }
}
